import { getPostSearchParams, isValueNumeric } from 'util/misc'
import { QuoteParams } from './types'

export const validPhoneNumberByCountry = (countryIso2: string, phone: string) => {
  switch (countryIso2) {
    case 'US':
      return new RegExp('^(?:\\+1s?)?(?:\\(?\\d{3}\\)?[\\s.-]?)?\\d{3}[\\s.-]?\\d{4}$').test(phone)
    default:
      return true
  }
}

export const cleanHtmlContent = (html: string, fontSize: string = '14px', lineHeight: string = '20px'): string => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')
  Array.from(doc.querySelectorAll('style, script')).forEach((tag) => tag.remove())
  Array.from(doc.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, div, li, strong, em, b, i')).forEach((el) => {
    if (el instanceof HTMLElement) {
      el.removeAttribute('style')
      el.style.fontSize = fontSize
      el.style.lineHeight = lineHeight
      el.style.margin = '0'
      el.style.padding = '0'
      el.style.display = 'inline'
    }
  })
  Array.from(doc.querySelectorAll('p, h1, h2, h3, h4, h5, h6, div, ul, li')).forEach((el) => {
    if (el instanceof HTMLElement) {
      el.replaceWith(...Array.from(el.childNodes))
    }
  })
  let cleanedHtml = doc.body.innerHTML
    .replace(/\n\s*\n/g, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim()
  return cleanedHtml
}

export const getAsNumberOrDefault = (n: unknown, defaultVal: number): number => {
  return isValueNumeric(n) ? Number(n) : defaultVal
}

export const getQuoteParams = (): QuoteParams => {
  const searchParams = getPostSearchParams()

  const quoteParams = {
    suggested_system_size_kw: getAsNumberOrDefault(searchParams.get('suggestedSystemSize'), 0),
    displayed_ppw: getAsNumberOrDefault(searchParams.get('lowestPricePerWatt'), 0),
    utility_bill_amount_monthly: getAsNumberOrDefault(searchParams.get('utilityBillAmount'), 0),
    estimated_proposed_savings_amount_lifetime: getAsNumberOrDefault(searchParams.get('savingsAmount'), 0),
    google_lead_id: searchParams.get('google_lead_id'),
    campaign_id: searchParams.get('cid'),
  }
  return quoteParams
}

export interface ProfileRequestOrigin {
  source: string
  medium: string
  campaign_id: string | null
}

export const getProfileRequestOrigin = (isLoggedInPro: boolean): ProfileRequestOrigin => {
  const { campaign_id } = getQuoteParams()

  const getSource = () => {
    const referrer = document.referrer
    if (!referrer) {
      return 'direct'
    }
    const isGoogleSearchReferrer = referrer.includes('google.com/search')
    if (isGoogleSearchReferrer) {
      return 'googleSearch'
    }
    try {
      const url = new URL(referrer)
      const sanitisedReferrer = url.hostname.replace(/^www\./, '').split('.')[0]
      return sanitisedReferrer
    } catch {
      return 'unknown'
    }
  }

  const source = getSource()

  return {
    source: source,
    medium: isLoggedInPro ? 'internal' : 'organic',
    campaign_id: campaign_id,
  }
}
